import { Controller } from "@hotwired/stimulus"

// Parcours contact (Questions / Partenariats / Recrutement) en deux écrans.
// Écran « choice » = choix du sujet ; écran « form » = formulaire. Le champ
// « lien » n'apparaît que pour le recrutement. Le serveur reste source de
// vérité ; ce contrôleur ne gère que la visibilité et la famille postée.
export default class extends Controller {
  static targets = ["screen", "familyField", "heading", "linkField"]
  static values = { headings: Object }

  selectFamily(event) {
    const family = event.target.value
    this.familyFieldTargets.forEach((f) => (f.value = family))
    if (this.hasHeadingTarget && this.headingsValue[family]) {
      this.headingTarget.textContent = this.headingsValue[family]
    }
    this.linkFieldTargets.forEach((el) =>
      el.classList.toggle("hidden", family !== "recruitment")
    )
    this.reveal("form")
  }

  back() {
    this.reveal("choice")
  }

  reveal(screen) {
    this.screenTargets.forEach((el) =>
      el.classList.toggle("hidden", el.dataset.screen !== screen)
    )
  }
}
